export class OptomaWuProjector {
    constructor(socket) {
        this.socket = socket;
        this.displayBlank = false;
        this.firmwareVersion = 'C009';
        this.power = false;
        this.videoInput = '7';
        this.volumeMute = false;
        // The video input query returns different values than the values used to set the input source.
        // This table maps the sent values to the reported values. This is the reverse of the table in
        // the driver.
        this.videoOutputCodes = {
            '1': '7',
            '2': '1',
            '4': '6',
            '5': '2',
            '6': '3',
            '9': '4',
            '10': '5',
            '11': '10',
            '14': '11',
            '16': '9',
            '15': '8',
            '17': '12',
            '18': '13',
            '19': '14',
            '20': '15',
            '21': '16',
            '22': '18',
            '23': '17',
            '24': '20',
        };
        this.asyncHandlers = [
            {
                name: 'displayBlankQuery',
                regExp: /~00355 1/i,
                callback: (match) => {
                    this.socket.send(`Ok${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /~0002 (.+)/i,
                callback: (match) => {
                    this.displayBlank = match[1] === '1';
                    this.socket.send(`P`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /~00122 1/i,
                callback: (match) => {
                    this.socket.send(`Ok${this.firmwareVersion}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /~00124 1/i,
                callback: (match) => {
                    this.socket.send(`Ok${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /~0000 (.+)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`P`);
                },
            },
            {
                name: 'videoInputQuery',
                regExp: /~00121 1/i,
                callback: (match) => {
                    this.socket.send(`Ok${this.videoInput}`);
                },
            },
            {
                name: 'videoInputSet',
                regExp: /~0012 (.+)/i,
                callback: (match) => {
                    if (match[1] in this.videoOutputCodes) {
                        this.videoInput = this.videoOutputCodes[match[1]];
                    }
                    this.socket.send(`P`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /~00356 1/i,
                callback: (match) => {
                    this.socket.send(`Ok${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /~0080 (.+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1';
                    this.socket.send(`P`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /~0081 (.+)/i,
                callback: (match) => {
                    // There is no query, so don't save value.
                    this.socket.send(`P`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`F`);
                },
            },
        ];
    }
}
OptomaWuProjector.emulatorType = 'socketEmulator';
OptomaWuProjector.key = '-MveI-93xmg0nYNWO0cO';
